import React, {useContext, useState} from "react";
import {errorState} from "../helpers";
import {FormFieldError} from "./form-field-error";
import { FormContext } from "./form-context"

/*
    You can pass args parameter with input wield attributes you want add.
    For text input (default) there is also default maxlength 255 which you need override in args if required
 */
function InputField(props) {
    const { formState } = useContext(FormContext);
    const [ fieldState, updateFieldState ] = useState({
        focused:false,
        value:''
    });

    function onFieldChange(e) {
        updateFieldState({
            ...fieldState,
            value:e.target.value
        });
    }

    return  (
        <div className={"form-field " + ((fieldState.value)?'filled':'') + ((fieldState.focused)?' focused':'')}>
            <label>{props.label}</label>
            <input
                type={(props.type)?props.label:"text"}
                className={"form-control " + errorState(formState, props.name)}
                name={props.name}
                {...props.args}
                {...(
                    ((props.type === 'text' || !props.type) && (!props.args || !props.args.maxlength))
                        ? {maxlength: 255}
                        : {}
                    )
                }
                onChange={onFieldChange}
                onFocus={e => updateFieldState({...fieldState, focused:true})}
                onBlur={e => updateFieldState({...fieldState, focused:false})}
            />
            <FormFieldError field={props.name} state={formState}/>
        </div>
    );
}

export { InputField };